import React from 'react';
import LoadingSpinner from './loadingSpinner'
class C18Blank extends React.Component{
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    if(this.state.loaded){
      return (
        <div>Blank</div>
      )
    }else{
      return <LoadingSpinner message="loading sites list..." />
    }
  }
}

export default C18Blank;
